import { Injectable, inject } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { MsalService } from '@azure/msal-angular';
import { Router } from '@angular/router';
import { b2cPolicies } from '@app/auth-config';

@Injectable({
  providedIn: 'root'
})
export class SharedService {
  private loadingSubject = new BehaviorSubject<boolean>(false);
  public loading$ = this.loadingSubject.asObservable();

  private userRoleSubject = new BehaviorSubject<string>('');
  public userRole$ = this.userRoleSubject.asObservable();

  private msalService = inject(MsalService);
  private router = inject(Router);

  setLoading(loading: boolean): void {
    this.loadingSubject.next(loading);
  }

  setUserRole(role: string): void {
    this.userRoleSubject.next(role);
  }

  getUserRole(): string {
    return this.userRoleSubject.value;
  }

  showSuccessMessage(): void {
    // Success message display - implementation pending
  }

  showErrorMessage(message?: string): void {
    // Placeholder for centralized error messaging; ignore message for now
    void message;
  }

  showWarningMessage(): void {
    // Warning message display - implementation pending
  }

  B2CLogin(): void {
    try {
      this.msalService
        .loginPopup({
          scopes: ['openid', 'profile', 'email'],
          authority: b2cPolicies.authorities.signUpSignIn.authority
        })
        .subscribe({
          next: () => {
            localStorage.setItem('b2c', 'true');
            this.router.navigate(['/wapi/home']);
          },
          error: () => {
            this.showErrorMessage('B2C login failed. Please try again.');
          }
        });
    } catch {
      this.showErrorMessage('Failed to initiate B2C login.');
    }
  }
}
